import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MUIDataTable from "mui-datatables";

function LogTable(props) {

const columns = ["Type", "Date/Time", "Duration (secs)", "Reason"];
const data = props.data.map(data => {
  return [data.logType, data.dateTime, data.duration/1000, data.reason.detail]
})

const options = {
  selectableRows: "none",
  rowsPerPageOptions: [10, 50, 100],
  rowsPerPage: 10,
  search: false
};

return (
  <MUIDataTable
    title={"Log"}
    data={data}
    columns={columns}
    options={options}
  />
  )
}

export default (LogTable);



// WEBPACK FOOTER //
// ./src/components/LogTable.js